<template>
    <div>
        <vueHeader :navNum="2"></vueHeader>

        <div class="banner">
            <img src="./../assets/img/travel/banner.jpg" alt="">
        </div>

        <div class="about">
            <div class="left">
                <p class="title">关于旅行</p>
                <p class="txt">我们在德国有多处基地可选，其中一处位于著名的摩泽尔河谷，在德国、法国、卢森堡大公国三个国家的交界处。距卢森堡首都市中心25km，距巴黎300KM，距法兰克福200KM，瑞士、比利时、荷兰和英吉利海峡隧道都近在咫尺。我们备有三个停机坪等候您的降临，当然，我们也可以提供您所需要的专车接送服务。</p>
                <p class="txt">我们提供的五星级度假酒店不仅能饱览摩泽尔河谷的风光，体验米其林三星餐厅的服务，更能聆听一座历史悠久城堡的故事。我们可以为您在摩泽尔河谷提供私人游艇，并可一直延伸到地中海、大西洋，或者著名的挪威峡湾。当然，如果您需要汽车，我们将为您提供全程专车（劳斯莱斯或奔驰AMG等系列），更可以应您的需求为您配置业界最高素质的职业司机和英、法、德语翻译或其他陪同人员。当然如果您有兴趣，我们还可以为您提供全球最为著名的纽博格林赛道的顶级驾驶体验以及阿尔卑斯山脉无与伦比的度假和滑雪体验。</p>
            </div>
            <div class="right">
                <img src="./../assets/img/travel/about.png" />
                <div class="bg"></div>
            </div>
        </div>

        <div class="introduce">
            <div class="introduce-title">我们提供</div>
            <ul>
                <li v-for="(item,index) in introduce" :key="index">
                    <img :src="item.img" />
                    <p class="title">{{item.title}}</p>
                    <p class="txt">{{item.txt}}</p>
                </li>
            </ul>
        </div>

        <div class="news">
            <div class="title">
                新闻资讯
                <router-link to="/travelList">
                    <div class="more">more</div>
                </router-link>
            </div>
            <swiper class="swiper" :options="swiperOption" ref="mySwiper" v-if="news.length">
                <!-- slides -->
                <swiper-slide v-for="(item,index) in news.slice(0,3)" :key="index">
                    <div class="item" @click="goArtical(item.id)">
                        <div class="news_img">
                            <img :src="item.cover" />
                            <div class="desc">{{item.txt}}</div>
                        </div>
                        <div class="bottom">
                            <p class="headline">{{item.title}}</p>
                            <p class="time">{{item.month}}-{{item.day}}</p>
                            <p class="txt">{{item.desc.substring(0,110)}}...</p>
                        </div>
                    </div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="point" slot="pagination" style="opacity:0"></div>
            </swiper>
        </div>

        <div class="consult">
            <div class="comment">
                <p class="headline">留言与咨询</p>
                <p class="eng">Message and consultation</p>
                <div class="line"></div>
                <div class="illustrate">
                    <p class="txt">如果您有意向在LOTO做抗衰老疗养，请您提前和我们做好预约和行程安排；如果您想通过我们来一次特别的旅行和生活体验，我们同样欢迎您的加入。</p>
                    <p class="txt">如果您还需要卢森堡大公国的税务和财务咨询，也请您留下您的咨询信息。</p>
                    <p class="txt">以上每一项，我们都可以提供对应的业界最高职业素养的人为您提供我们能做到的最为极致服务。</p>
                </div>
                <div class="info">
                    <input type="text" v-model.trim="name" placeholder="姓名" />
                    <input type="text" v-model.trim="phone" placeholder="邮箱" />
                    <textarea v-model.trim="consult" placeholder="留下您想咨询或感兴趣的问题，我们将会派专人联系您"></textarea>
                    <div class="btn" @click="submit()">确认提交</div>
                </div>
            </div>
        </div>

        <vueFooter></vueFooter>
    </div>
</template>

<script>
import vueHeader from '@/components/header'
import vueFooter from '@/components/footer'
export default {
    data() {
        return {
            introduce: [
                {
                    img: require('./../assets/img/health/icon1.png'),
                    title: '美食',
                    txt: '我们提供的米其林三星餐厅让您开启一段奇妙的感官体验之旅，涵盖高水准多品种美食，是一场真正的美食之旅'
                },
                {
                    img: require('./../assets/img/health/icon2.png'),
                    title: '住宿',
                    txt: '我们提供的五星级度假酒店为您奉献豪华、惬意的尊崇享受,让您拥有无与伦比的入住体验，享受更舒心的旅途'
                },
                {
                    img: require('./../assets/img/health/icon3.png'),
                    title: '出行',
                    txt: '我们提供劳斯莱斯或奔驰AMG等一系列的专车。同时为您配置业界最高素质的职业司机，让您免去旅途的驾驶疲惫'
                },
                {
                    img: require('./../assets/img/health/icon4.png'),
                    title: '服务',
                    txt: '我们提供专业的翻译和陪同人员，帮助您更好更快地制定旅行路线，行程随时调整，让您的旅行更简单更从容'
                },
            ],
            news: [],
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 0,
                slidesPerGroup: 3,
                // loop: true, //循环
                initialSlide: 0, //设定初始化时slide的索引
                //autoplay: false, //自动播放
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                speed: 1200, //滑动速度
                direction: "horizontal", //滑动方向
                // grabCursor : true, //小手掌抓取滑动
                on: {
                },
                pagination: {
                    //分页器设置
                    el: ".point",
                    clickable: true
                }
            },
            name: '',
            phone: '',
            consult: ''
        }
    },

    mounted() {
        window.scrollTo(0, 0);
        this.news = this.$store.state.travelArtical;
    },

    methods: {
        goArtical(id) {
            this.$store.commit('changetravelArticalId', id);
            this.$router.push({ path: '/travelContent' });
        },
        submit() {
            let _this = this;
            if (this.name == '') {
                this.$kiko_message({
                    message: '请输入姓名',
                    time: 1000
                });
            } else if (this.phone == '') {
                this.$kiko_message({
                    message: '请输入邮箱',
                    time: 1000
                });
            } else if (this.consult == '') {
                this.$kiko_message({
                    message: '请输入您想咨询或感兴趣的问题',
                    time: 1000
                });
            } else {
                $.ajax({
                    url: 'http://116.62.23.229:8090/leaveMassage/messageAddLoto',
                    type: 'post',
                    data: {
                        name: _this.name,
                        email: _this.phone,
                        content: _this.consult
                    },
                    success(data) {
                        console.log(data);
                        if (data.success) {
                            _this.$kiko_message({
                                message: '提交成功',
                                time: 1000
                            });
                            _this.name = '';
                            _this.phone = '';
                            _this.consult = '';
                        } else {
                            _this.$kiko_message({
                                message: data.msg,
                                time: 1000
                            });
                        }
                    }
                })
            }
        }
    },

    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },

    components: {
        vueHeader,
        vueFooter
    },
}

</script>

<style scoped lang='less'>
@import "./../assets/css/travel.less";
</style>


// WEBPACK FOOTER //
// src/views/travel.vue